import React from "react";

import { Link, InfoSmIcon } from "@packages/ds";
import { useIntl, FormattedMessage } from "react-intl";
import styled from "styled-components";

export const Aside = () => {
  const intl = useIntl();

  return (
    <AsideWrapper>
      <MainHeading>
        {intl.formatMessage({
          id: "carbon.emissions.overview.title"
        })}
      </MainHeading>
      <AsideSection>
        <AsideHeading>
          {intl.formatMessage({
            id: "carbon.emissions.calculation.title"
          })}
          <InfoSmIcon fill="var(--mode-vector-neutral-default)" />
        </AsideHeading>
        <AsideText>
          <FormattedMessage
            id="carbon.emissions.calculation.explanation"
            values={{
              a: chunks => <AsideLink href="/">{chunks}</AsideLink>
            }}
          />
        </AsideText>
      </AsideSection>
      <AsideSection>
        <AsideHeading>
          {intl.formatMessage({
            id: "carbon.emissions.affects.title"
          })}
        </AsideHeading>
        <AsideText>
          <FormattedMessage id="carbon.emissions.affects.explanation" />
        </AsideText>
      </AsideSection>
    </AsideWrapper>
  );
};

const AsideWrapper = styled.div`
  background-color: var(--mode-bg-neutral-weakest);
  padding: 32px 24px;
  display: inline-flex;
  flex-direction: column;
`;

const AsideSection = styled.section`
  margin-top: 6px;
  margin-bottom: 24px;
  border-radius: 8px;
  border: 1px solid var(--mode-border-neutral-weakest);
  padding: 16px 24px 24px;
`;

const MainHeading = styled.h2`
  color: var(--mode-text-neutral-default);
  font-size: var(--fs-xxl);
  font-weight: 700;
`;

const AsideHeading = styled.h2`
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const AsideText = styled.p`
  color: var(--mode-text-neutral-default);
  font-size: var(--fs-m);
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;

const AsideLink = styled(Link)`
  font-size: var(--fs-m);
`;
